import {
  SMS_DONATION_LOADING,
  SMS_DONATION_SUCCESS,
  SMS_DONATION_FAILURE,
} from "redux/types";
import { Dispatch } from "redux";
import { createNewItemService } from "services/createNewItemService";
import { smsDonationUrl } from "api/apiUrls";

export const smsDonationActions = (data: any) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: SMS_DONATION_LOADING, payload: true });
    const response = await createNewItemService(
      `${smsDonationUrl}`,
      data,
      "",
      "json"
    );

    dispatch({ type: SMS_DONATION_SUCCESS, payload: response.data });
  } catch (err) {
    dispatch({ type: SMS_DONATION_FAILURE, payload: err });
  } finally {
    dispatch({ type: SMS_DONATION_LOADING, payload: false });
  }
};
